import { StyledIconButton, StyledIconButtonProps } from './IconButton.style';

export const IconButton = ({ displayStyle, ...props }: StyledIconButtonProps) => (
  <StyledIconButton displayStyle={displayStyle} {...props} />
);
